var map = {
	"./close.svg": 2182,
	"./consultant.svg": 7353,
	"./dashboard.svg": 9290,
	"./delete.svg": 2355,
	"./edit.svg": 2878,
	"./guide.svg": 4834,
	"./publish.svg": 887,
	"./save.svg": 1097,
	"./search.svg": 6234,
	"./setting.svg": 8662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;